import { render, staticRenderFns } from "./NavigationBarConfig.vue?vue&type=template&id=0b74be2f"
import script from "./NavigationBarConfig.vue?vue&type=script&lang=js"
export * from "./NavigationBarConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports